/*
 *   File : header.js
 *   Author : https://evoqins.com
 *   Description : Header component
 *   Integrations : js-cookie,react-toastify
 *   Version : 1.0.0
*/

import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { useLocation, useNavigate } from 'react-router-dom';
import { Modal } from 'bootstrap';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';

// Custom component
import { OverLay } from '../Others';
import LeftNavigationWidget from './left-navigation';
import { ResetPasswordModal } from '../Modal';
import { Icon } from '../Icon';
import { APIService } from '../../Service';

const CustomHeader = (props) => {

    const PROFILE_DATA = useSelector((store) => store.Reducer.PROFILE_DATA);

    const navigate = useNavigate();
    const location = useLocation();

    const [toggleMore, setToggleMore] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [notificationCount, setNotificationCount] = useState(0);
    const [loader, setLoader] = useState(true);

    useEffect(() => {
        const opened_modal = document.querySelector('.modal.show');
        if (opened_modal) {
            const modal = Modal.getInstance(opened_modal);
            modal.hide();

            setShowPassword(false);
        }
    }, [location]);

    useEffect(() => {
        setLoader(false);
        if (props.token === 'country_admin') {
            _getNotificationCount();
        }
    }, [props.token, location.pathname, location?.state?.mark_all]);

    useEffect(() => {
        if (showPassword === true) {
            const reset_modal = new Modal(document.getElementById('reset-password-modal'));
            reset_modal.show();
        }
    }, [showPassword]);

    // handle logout
    const _handleLogout = () => {
        Cookies.remove("access_token", { path: '/', domain: process.env.REACT_APP_DOMAIN });
        Cookies.remove("admin_type", { path: '/', domain: process.env.REACT_APP_DOMAIN });
        Cookies.remove("access_token");
        Cookies.remove("admin_type");
        setTimeout(() => {
            window.location.replace("/");
        }, 100);
    };

    // handle close offcanvas 
    const _handleCloseOffcanvas = () => {
        var button = document.getElementById("offcanvas-close");
        button.click();
    };

    // Reset password 
    const _handleChangePassword = () => {
        setShowPassword(true);
    };

    // API - Get notification count
    const _getNotificationCount = () => {
        let is_post = false;
        let url = 'CA/notifications/count';
        let data = {};

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                setNotificationCount(response.data[0].notification_count);
            } else { }
        });
    };

    // API - Change password country admin
    const _changePasswordCountryAdmin = async (new_password, current_password) => {
        let valid = false;
        setLoader(true);

        let is_post = true;
        const url = "auth/change-password";
        const data = {
            "current_password": current_password,
            "new_password": new_password
        };

        await APIService(is_post, url, data).then((response) => {
            toast.dismiss();
            if (response.status_code === 200) {
                valid = true;
                toast.success("Password changed successfully", {
                    type: "success"
                });
                setShowPassword(false);
            } else {
                valid = false;
                toast.error(response.message, {
                    type: "error"
                });
            }
            setLoader(false);
        });
        return valid;
    };

    // API - Change password super admin
    const _changePasswordSuperAdmin = async (new_password, current_password) => {
        let valid = false;
        setLoader(true);

        let is_post = true;
        const url = "general/change-password";
        const data = {
            "current_password": current_password,
            "new_password": new_password
        };

        await APIService(is_post, url, data).then((response) => {
            toast.dismiss();
            if (response.status_code === 200) {
                valid = true;
                toast.success("Password changed successfully", {
                    type: "success"
                });
                setShowPassword(false);
            } else {
                valid = false;
                toast.error(response.message, {
                    type: "error"
                });
            }
            setLoader(false);
        });
        return valid;
    };

    return (
        <div className={`${props.token === 'super_admin' ? `e-bg-azureish-white` : `e-bg-lavender-blush-light`} padding-32px-tb`}>
            <div className='d-flex justify-content-space-between'>
                <div className='ps-3'>
                    <Icon icon="hamburger"
                        size={"24px"}
                        className='cursor-pointer d-xl-block d-lg-block d-md-none d-none'
                        onPress={props.handleToggle} />

                    <Icon icon="hamburger"
                        size={"24px"}
                        className='cursor-pointer d-xl-none d-lg-none d-md-block d-block'
                        data-bs-toggle="offcanvas"
                        data-bs-target="#left-navigation-offcanvas" />
                </div>

                {/* offcanvas */}
                <div className="offcanvas offcanvas-start w-auto" data-bs-backdrop="static" data-bs-scroll="false"
                    tabIndex="-1"
                    id="left-navigation-offcanvas"
                    aria-labelledby="offcanvasWithBothOptionsLabel">
                    <div className="overflow-auto e-offcanvas-wrapper">
                        <div className="text-end pe-3">
                            <button id="offcanvas-close"
                                type="button"
                                className="btn-close mt-2 d-none"
                                data-bs-dismiss="offcanvas"
                                aria-label="Close"></button>
                        </div>
                        <LeftNavigationWidget type="offcanvas"
                            token={props.token}
                            profileData={PROFILE_DATA}
                            handleCloseOffCanvas={_handleCloseOffcanvas} />
                    </div>
                </div>

                <div className='d-flex justify-content-end pe-4 me-3 align-items-center gap-30px'>

                    {Object.keys(PROFILE_DATA).length !== 0 &&
                        <div>
                            <div className='d-flex align-items-center gap-2'>
                                <img src={require("../../Assets/Image/admin.svg").default}
                                    draggable={false}
                                    height={24}
                                    width={24}
                                    className='e-border-radius-24'
                                    alt='admin' />
                                <div>
                                    <p className='mb-0 e-text-yankees-blue e-alt-font-noto-sans e-font-12 e-font-weight-600 line-height-16px'>
                                        {PROFILE_DATA.username}, {PROFILE_DATA.country}
                                    </p>
                                    <p className='mb-0 e-text-rhythm e-alt-font-noto-sans e-font-10 e-font-weight-400 line-height-14px'>
                                        {PROFILE_DATA.admin_type || "-"}
                                    </p>
                                </div>
                            </div>
                        </div>
                    }

                    {props.token === 'country_admin' &&
                        <div className='position-relative cursor-pointer  '
                            onClick={() => navigate("/notification")}>
                            <Icon icon="notification"
                                size={"24px"} />
                            {notificationCount !== 0 &&
                                <span className=" e-alt-font-noto-sans e-font-10 e-font-weight-500 line-height-12px position-absolute top-4px left-18px translate-middle badge rounded-pill e-bg-fire-engine-red p-1 d-flex align-items-center justify-content-center" style={{ width: "20px", height: "20px" }}>
                                    {notificationCount < 100 ? notificationCount : "99+"}
                                </span>
                            }
                        </div>
                    }

                    <div className='d-flex align-items-center gap-3'>
                        <div className='e-dropdown-more-wrapper position-relative'>
                            <Icon icon="menu"
                                size={"24px"}
                                className="cursor-pointer"
                                onPress={() => setToggleMore(!toggleMore)} />

                            {toggleMore &&
                                <>
                                    <OverLay isOpen={toggleMore} onClose={() => setToggleMore(!toggleMore)} />
                                    <div className="e-dropdown-more e-bg-white text-start top-24px right-neg-14px z-index-99"
                                        onClick={() => setToggleMore(!toggleMore)}>
                                        <p className='mb-4 e-text-rich-black-light e-alt-font-noto-sans e-font-12 e-font-weight-400 line-height-16px cursor-pointer text-decoration-hover-underline'
                                            onClick={_handleChangePassword} >
                                            Change password
                                        </p>
                                        <p className='mb-0 e-text-rich-black-light e-alt-font-noto-sans e-font-12 e-font-weight-400 line-height-16px cursor-pointer text-decoration-hover-underline'
                                            onClick={_handleLogout} >
                                            Logout
                                        </p>
                                    </div>
                                </>
                            }
                        </div>


                        <div onClick={() => navigate("/")} className='cursor-pointer'>
                            <img src={require("../../Assets/Image/jotun.svg").default}
                                draggable={false}
                                height={32}
                                width={110}
                                alt='jotun' />
                        </div>
                    </div>
                </div>
            </div>

            {/* Reset Password modal */}
            {showPassword &&
                <ResetPasswordModal loading={loader}
                    closeModal={() => {
                        setShowPassword(false);
                    }}
                    reset={props.token === 'super_admin' ?
                        _changePasswordSuperAdmin :
                        _changePasswordCountryAdmin} />
            }
        </div>
    )
}

export default CustomHeader;